import { Box, Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { RightElementProps } from './OperationalPlanner.types'

export const RightElement = ({
  planningScenarioAccess,
  reportsAccess,
  plannedProductionAccess,
  bgColor,
}: RightElementProps) => {
  const navigate = useNavigate()
  return (
    <Box display="flex">
      {planningScenarioAccess && (
        <Box>
          <Button
            variant="contained"
            sx={{
              backgroundColor: bgColor,
            }}
            onClick={() => navigate('/system-of-records')}
          >
            System of records
          </Button>
        </Box>
      )}
      {reportsAccess && (
        <Box ml={1}>
          <Button
            variant="contained"
            sx={{
              backgroundColor: bgColor,
            }}
            onClick={() => navigate('/reports')}
          >
            Reports
          </Button>
        </Box>
      )}
    </Box>
  )
}
